import Image from 'next/image';
import cn from 'classnames';
import Link from 'next/link';
import { getPageUrl } from '@/components/collections/helpers';
import { Content } from './types';

const Template = ({
  title,
  description,
  cta,
  banner,
  theme = 'light',
}: Content) => (
  <>
    {cta.link && (
      <Link href={getPageUrl(cta.link)} prefetch>
        <div
          className={cn('relative flex h-full py-10 xxs:py-0 lg:px-20', {
            'bg-teal-500 text-gray-700': theme === 'light',
            'bg-gray-700 text-white': theme === 'dark',
          })}
          // eslint-disable-next-line react/forbid-dom-props
          style={{
            background:
              theme === 'light'
                ? 'linear-gradient(90deg, rgba(146,247,250,1) 0%, rgba(146,247,250,1) 60%, rgba(146,250,213,1) 100%)'
                : '',
          }}
        >
          <div className="reebelo-container flex w-full items-center lg:justify-center">
            <div className="z-10 text-sm xxs:max-w-[280px] xs:max-w-[300px] sm:max-w-[400px] md:max-w-[500px] lg:max-w-[400px]">
              <h1 className="text-xl font-bold sm:text-2xl">{title}</h1>
              <p className="mt-3 hidden lg:block">{description.desktop}</p>
              <p className="mt-3 lg:hidden">{description.mobile}</p>
              <div
                className={cn(
                  'mt-5 flex h-8 w-fit items-center justify-center rounded-full px-5 text-xs font-bold',
                  {
                    '!bg-gray-700 text-white': theme === 'light',
                    '!bg-teal-500 text-gray-700': theme === 'dark',
                  },
                )}
              >
                {cta.label}
              </div>
            </div>
            <div className="hidden h-full lg:block">
              <Image
                src={banner.desktop}
                alt="Desktop Hero"
                className="h-full w-auto object-contain"
                quality={100}
                height={600}
                width={800}
              />
            </div>
            <div className="absolute right-0 h-full opacity-20 xxs:right-[-75px] xxs:opacity-100 xs:right-0 lg:hidden">
              <Image
                src={banner.mobile}
                alt="Mobile Hero"
                className="h-full w-auto object-contain"
                quality={100}
                height={600}
                width={800}
              />
            </div>
          </div>
        </div>
      </Link>
    )}
  </>
);

export default Template;
